import styled from "styled-components"

export const TagEditorWrapper = styled.div<{
    tableView: boolean
}>`
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-bottom: ${(props) => (props.tableView ? "0" : "8px")};
`
export const TagList = styled.div<{
    tableView: boolean
}>`
    margin-bottom: ${(props) => (props.tableView ? "0" : "8px")};
`
export const Tag = styled.div`
    display: flex;
    width: fit-content;
    float: left;
    margin-top: 3px;
    margin-right: 5px;
    padding: 2px 8px;
    border-radius: 2px;
    font-size: 13px;
    font-family: ${(props) => props.theme.openSans};
    color: ${(props) => props.theme.tagColor};
    background: ${(props) => props.theme.tagBackground};
`
export const CloseButton = styled.div`
    user-select: none;
    margin-left: 7px;
    cursor: pointer;

    & > i {
        font-weight: bold;
        font-size: 10px;
        color: ${(props) => props.theme.tagCloseButtonColor};
        transition: 0.1s ease;

        &:hover {
            color: ${(props) => props.theme.tagCloseButtonHoverColor};
            transition: 0.1s ease;
        }
    }
`
export const TagDropdownList = styled.div<{
    show: boolean
}>`
    width: 100%;
    height: ${(props) => (props.show ? "100%" : 0)};
    max-height: 400px;
    margin-top: ${(props) => (props.show ? "10px" : 0)};
    overflow-y: scroll;
    border: ${(props) => (props.show ? "1px" : "0")} solid;
    border-color: ${(props) => props.theme.selectDropdownBackground};
    background: ${(props) => props.theme.selectDropdownBackground};
`
export const TagDropdownItem = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    padding: 6px 24px 6px 12px;
    font-size: 14px;
    cursor: pointer;
    color: ${(props) => props.theme.selectDropdownItemColor};
    background: transparent;
    transition: 0.2s ease;
    
    &:hover {
        color: ${(props) => props.theme.selectDropdownItemHoverColor};
        background: ${(props) => props.theme.selectDropdownHoverBackground};
    }
`
export const CreateFromSearch = styled(TagDropdownItem)`
    min-height: 35px;
    color: ${(props) => props.theme.tagCreateFromSearchColor};
    
    & > i {
        font-size: 20px;
    }
`
